module.exports = __webpack_public_path__ + "static/img/2.a5a4df9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia/2.png
// module id = 52f8
// module chunks = 1